import ENTITY_DATA from "../../../../data/index.js";
import makeFormRequest from "../../../../helpers/form-request.js";
import ServerResponse from "../../../../helpers/render-server-response.js";
import Request from "../../../../helpers/request.js";
import APP_COMPONENTS from "../components/index.js";
export default {
    execute: async (data) => {
        const { id, form, submitBtn } = data;
        const formRequest = makeFormRequest({ form, submitBtn });
        const response = await Request.post('/services/delete', { id });
        formRequest.afterResponse(false);
        if (response.success) {
            ServerResponse.show({
                resp: response,
                respTitle: 'SUCCESS',
                respText: `Service deleted successfully.`
            });
            APP_COMPONENTS.serviceForms.remove(id);
            ENTITY_DATA.removeById(id);
            return;
        }
        ServerResponse.show({
            resp: response,
            respTitle: 'ERROR',
            respText: response.error
        });
    }
};
